const drinkMenu = [
  {
    nama: "Es Teh Manis",
    deskripsi: "Teh manis segar dengan es batu.",
    harga: 5000,
    foto: "drink/es-teh-manis.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Kopi Hitam",
    deskripsi: "Kopi hitam panas khas Indonesia.",
    harga: 8000,
    foto: "drink/kopi-hitam.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Jus Alpukat",
    deskripsi: "Jus alpukat segar dengan susu coklat.",
    harga: 15000,
    foto: "drink/jus-alpukat.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Susu Jahe",
    deskripsi: "Susu hangat dicampur jahe segar.",
    harga: 12000,
    foto: "drink/susu-jahe.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Es Jeruk",
    deskripsi: "Jeruk peras dingin dengan es batu.",
    harga: 7000,
    foto: "drink/es-jeruk.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Milkshake Coklat",
    deskripsi: "Milkshake coklat dingin dan creamy.",
    harga: 18000,
    foto: "drink/milkshake-coklat.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Teh Tarik",
    deskripsi: "Teh tarik khas Malaysia yang creamy.",
    harga: 10000,
    foto: "drink/teh-tarik.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Kopi Susu",
    deskripsi: "Kopi dicampur susu kental manis.",
    harga: 10000,
    foto: "drink/kopi-susu.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Jus Mangga",
    deskripsi: "Jus mangga manis dan segar.",
    harga: 13000,
    foto: "drink/jus-mangga.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Wedang Jahe",
    deskripsi: "Minuman jahe panas penghangat badan.",
    harga: 9000,
    foto: "drink/wedang-jahe.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Es Cincau",
    deskripsi: "Minuman dingin dengan cincau hitam.",
    harga: 8000,
    foto: "drink/es-cincau.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Smoothie Stroberi",
    deskripsi: "Smoothie stroberi segar dan creamy.",
    harga: 20000,
    foto: "drink/smoothie-stroberi.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Jus Semangka",
    deskripsi: "Jus semangka dingin pelepas dahaga.",
    harga: 10000,
    foto: "drink/jus-semangka.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Thai Tea",
    deskripsi: "Teh susu khas Thailand dengan es.",
    harga: 15000,
    foto: "drink/thai-tea.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
  {
    nama: "Air Mineral",
    deskripsi: "Air mineral botol dingin.",
    harga: 5000,
    foto: "drink/air-mineral.jpg",
    stok: Math.random() >= 0.5 ? true : false,
  },
];

export default drinkMenu;
